<p>
  assig-link-to-domain works!
</p>
